import { createFileRoute } from "@tanstack/react-router";
import LansareTractoare from "@/pages/LansareTractoare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/lansare-tractoare/")({
  head: () => routeHead("/lansare-tractoare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LansareTractoare />
  );
}
